import { applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import promise from 'redux-promise';

import { HttpClient } from '@sayyesschool/frontend/clients/http';
import { API_URL } from '@sayyesschool/frontend/constants';
import { middleware as notification } from '@sayyesschool/frontend/store/features/notification';
import request from '@sayyesschool/frontend/store/middleware/request';
import storage from '@sayyesschool/frontend/store/middleware/storage';

const http = new HttpClient(API_URL);

export default composeWithDevTools(
    applyMiddleware(promise, storage(http), request(http), notification)
);